export default __webpack_public_path__ + "static/media/gallery_01.51df63e5.jpg";